import {createContext, use} from 'react'

import styles from './BoardMoveRefusal.module.css'
import type {SavedViewsBoardItem} from './types'

type GetMoveRefusal = (item: SavedViewsBoardItem) => string | undefined

/**
 * Why a card can never be moved on the board around it, or `undefined` on a board that moves
 * nothing. A context rather than an argument to `renderCard`, so the host card is not redrawn
 * for it.
 */
export const BoardMoveRefusalContext = createContext<GetMoveRefusal | undefined>(undefined)

/**
 * Why a card cannot be moved, as text inside the card. `data-drag-disabled` on the frame is
 * a styling hook that assistive technology cannot read, so the reason has to be written out.
 */
export function BoardMoveRefusal({item}: {item: SavedViewsBoardItem}) {
  const refusal = use(BoardMoveRefusalContext)?.(item)
  if (refusal === undefined) return null

  return <p className={styles.moveRefusal}>{refusal}</p>
}
